import router from "./router";
import store from "./store";

//modules
import metaModule from "./modules/meta";
import { customerModule, customerGlobalModule } from "./modules/customer";
import {
  transaksiModule,
  transaksiSnapcleanModule,
  depositModule,
  epaymentModule,
} from "./modules/transaksi-global";
import penghapusanTransaksiGlobalModule from "./modules/rekap-penghapusan-transaksi-global";
import {
  pembatalanReguler,
  pembatalanSnapclean,
  pembatalanDeposit,
  pembatalanEpayment,
} from "./modules/penghapusan-transaksi";
import afiliasi from "./modules/afiliasi";
import waAutosender from "./modules/wa-autosender";
import waStatus from "./modules/wa-status";
import waBlast from "./modules/wa-blast";
import referral from "./modules/referral";
import {
  outletModule,
  layananModule,
  layananSnapcleanModule,
  snapConsole,
  mesin,
  daftarItemModule,
} from "./modules/outlet";
import mesinEdcModule from "./modules/mesin-edc";
import settlementEdcGlobalModule from "./modules/settlement-edc-global";
import pengaturanUmumModule from "./modules/pengaturan-umum";
import rekeningBankModule from "./modules/rekening-bank";
import {
  setoranKasOutletModule,
  setoranKasWorkshopModule,
} from "./modules/setoran-kas";
import {
  permintaanKasOutletModule,
  permintaanKasWorkshopModule,
} from "./modules/permintaan-kas";
import { biayaOutletModule, biayaWorkshopModule } from "./modules/biaya";
import underConstructionModule from "./modules/under-construction";
import invoiceModule from "./modules/invoice";
import detailPenerimaanModule from "./modules/detail-penerimaan";
import komplainQrisModule from "./modules/komplain-qris";
import trainingProgram from "./modules/training-program";
import kampusModule from "./modules/kampus";
import whitelabel from "./modules/whitelabel";

const modules = {
  metaModule: metaModule,
  outletModule: outletModule,
  layananModule: layananModule,
  layananSnapcleanModule: layananSnapcleanModule,

  customerModule: customerModule,
  customerGlobalModule: customerGlobalModule,

  transaksiModule: transaksiModule,
  transaksiSnapcleanModule: transaksiSnapcleanModule,
  depositModule: depositModule,
  epaymentModule: epaymentModule,

  penghapusanTransaksiGlobalModule,
  pembatalanTransaksiRegulerModule: pembatalanReguler,
  pembatalanTransaksiSnapcleanModule: pembatalanSnapclean,
  pembatalanTopupDepositModule: pembatalanDeposit,
  pembatalanTopupEpaymentModule: pembatalanEpayment,

  afiliasiModule: afiliasi,

  waAutosenderModule: waAutosender,
  waBlastModule: waBlast,
  waStatusModule: waStatus,
  underConstructionModule,
  invoiceModule,

  referralModule: referral,
  snapConsoleModule: snapConsole,
  daftarItemModule: daftarItemModule,
  snapMesinModule: mesin,
  mesinEdcModule,
  settlementEdcGlobalModule,
  pengaturanUmumModule,
  rekeningBankModule,
  setoranKasOutletModule,
  setoranKasWorkshopModule,
  permintaanKasOutletModule,
  permintaanKasWorkshopModule,
  biayaOutletModule,
  biayaWorkshopModule,
  detailPenerimaanModule,
  komplainQrisModule,

  trainingProgram: trainingProgram,
  kampusModule: kampusModule,
  whitelabel: whitelabel,
};

const registerModule = (name, module) => {
  if (module.store) {
    store.registerModule(name, module.store);
  }

  if (module.router) {
    module.router(router);
  }
};

export const registerModules = () => {
  Object.keys(modules).forEach((moduleKey) => {
    const module = modules[moduleKey];
    registerModule(moduleKey, module);
  });
};
